import { post } from './http'

export function getRobotsApi() {
  return post('/v1/gpt/get_robots', {})
}
